/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { useIntl } from 'react-intl'
import { PageTitle } from '../../../_metronic/layout/core'
import { ReportsChart } from './ReportsChart'

const DashboardPage: FC = () => (
  <>
    <div className='row g-5 g-xl-5 mb-5 mb-xl-10 mt-lg-5'>

      <div className='col-xxl-6'>
        <ReportsChart className='' />

      </div>
     
    </div>
  </>
)

const DashboardWrapper: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.DASHBOARD' })}</PageTitle>
      <DashboardPage />
    </>
  )
}

export { DashboardWrapper }

